/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesReportTotals
 */
export interface SalesReportTotals {
    /**
     * 
     * @type {number}
     * @memberof SalesReportTotals
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof SalesReportTotals
     */
    estimated_sales: string;
    /**
     * 
     * @type {string}
     * @memberof SalesReportTotals
     */
    cost: string;
    /**
     * 
     * @type {string}
     * @memberof SalesReportTotals
     */
    commission: string;
    /**
     * 
     * @type {string}
     * @memberof SalesReportTotals
     */
    estimated_net: string;
    /**
     * 
     * @type {Date}
     * @memberof SalesReportTotals
     */
    first_redemption: Date | null;
}

/**
 * Check if a given object implements the SalesReportTotals interface.
 */
export function instanceOfSalesReportTotals(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "estimated_sales" in value;
    isInstance = isInstance && "cost" in value;
    isInstance = isInstance && "commission" in value;
    isInstance = isInstance && "estimated_net" in value;
    isInstance = isInstance && "first_redemption" in value;

    return isInstance;
}

export function SalesReportTotalsFromJSON(json: any): SalesReportTotals {
    return SalesReportTotalsFromJSONTyped(json, false);
}

export function SalesReportTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesReportTotals {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'estimated_sales': json['estimated_sales'],
        'cost': json['cost'],
        'commission': json['commission'],
        'estimated_net': json['estimated_net'],
        'first_redemption': (json['first_redemption'] === null ? null : new Date(json['first_redemption'])),
    };
}

export function SalesReportTotalsToJSON(value?: SalesReportTotals | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'estimated_sales': value.estimated_sales,
        'cost': value.cost,
        'commission': value.commission,
        'estimated_net': value.estimated_net,
        'first_redemption': (value.first_redemption === null ? null : value.first_redemption.toISOString()),
    };
}

